"use client";

import * as React from "react";
import Link from "next/link";
import { ChartCard, PreviewLineChart } from "@/components";
import { SparklesIcon } from "@/icons";
import { useShareRate } from "@/hooks/use-shares";

export function Shares() {
  const { data, isLoading } = useShareRate();
  const fields = React.useMemo(() => data?.chart?.fields, [data]);

  const lines = React.useMemo(() => {
    if (!fields) return [];
    return Object.keys(fields).map((el) => ({
      dataKey: el,
      name: fields[el].title,
      stroke: fields[el].color,
    }));
  }, [fields]);

  return (
    <Link href="/explore/shares" className="block h-full cursor-pointer">
      <ChartCard
        title="Shares"
        icon={<SparklesIcon size={20} color="#FF0F6F" />}
        isLoading={isLoading}
        accent="T-Shares"
        description="Share rate, T-Share price, and staking economics"
      >
        <PreviewLineChart data={data?.data ?? []} lines={lines} />
      </ChartCard>
    </Link>
  );
}
